module.exports = __webpack_public_path__ + "img/pos2_banner1.bdee90de.png";